module.exports = __webpack_public_path__ + "static/media/cc_icon-jeanie.78fe27ef.svg";